import { Box, Button, Stack, Typography } from '@mui/material'
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined'
import { DashboardExports } from './DashboardExports'
import { styles } from './DashboardBanner.styles'

interface Props {
  organizationId: number
  reportingYearId: number
  onPrint: () => void
}

export const DashboardBanner = ({ organizationId, reportingYearId, onPrint }: Props): JSX.Element => (
  <Box sx={styles.banner}>
    <Box>
      <Typography variant='h2' sx={styles.bannerText}>Data Dashboard</Typography>
      <Typography variant='body2' sx={styles.bannerText}>Select a goal and filter by organization level to explore your data.</Typography>
    </Box>
    <Stack gap='8px' data-hide-in-pdf>
      <DashboardExports organizationId={organizationId} reportingYearId={reportingYearId} />
      <Button variant='contained' onClick={onPrint} endIcon={<PrintOutlinedIcon />} data-testid='p2pPrintScreens' sx={styles.bannerButton}>
        Print Screens
      </Button>
    </Stack>
  </Box>
)
